// extracted by mini-css-extract-plugin
module.exports = {"GutenbergModule":"GutenbergModule_GutenbergModule__XoQdm","loader":"GutenbergModule_loader__8VWIN"};